/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';

import { IMfrmAdjustableBaseDimensionsViewProps } from './mfrm-adjustable-base-dimensions';

export default (props: IMfrmAdjustableBaseDimensionsViewProps) => {
    const { viewButtons, selectedSizeDimensions, selectedViewDimensions, displayImage, sizeSelection } = props;

    return (
        <div className='mfrm-adj-base'>
            <h2>Dimensions</h2>
            {sizeSelection}
            <div className='row mfrm-adj-base__content-container'>
                <div className='row mfrm-adj-base__content-left'>
                    {selectedSizeDimensions}
                    {displayImage}
                    {selectedViewDimensions}
                </div>
                <div className='mfrm-adj-base__adjust'>
                    <div className='mfrm-adj-base__adjust-header'> Adjust Your View </div>
                    {viewButtons}
                </div>
            </div>
        </div>
    );
};
